"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBuildingOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M21 9V3H4v25h24V9zm-2 17H6V5h13v21zm7 0h-5V11h5z" }),
        React.createElement("path", { d: "M9 9h2v3H9zM14 9h2v3h-2zM9 14h2v3H9zM14 14h2v3h-2zM9 19h2v3H9zM14 19h2v3h-2z" })));
}
exports.default = SvgBuildingOutline;
//# sourceMappingURL=BuildingOutline.js.map